import React from 'react';
import PropTypes from 'prop-types';
import useTranslation from 'next-translate/useTranslation';

// Components
import Button from '../../../shared/Button';

// Styles
import styles from './notInterestedsSignUpSection.module.scss';

const NotInterestedSignUpSection = ({ companyColor, onInterestedClick }) => {
  const { t } = useTranslation('common');

  return (
    <section id="not-interested-sign-up-section" className={styles.container}>
      <div>
        <h2 className={styles.heading}>
          {t('description_page.not_interested_sign_up_section.title')}
        </h2>

        <p className={styles.description}>
          {t('description_page.not_interested_sign_up_section.description')}
        </p>

        <div className={styles.signUp}>
          <div className={styles.button}>
            <Button
              style={{
                border: `2px solid ${companyColor}`,
                color: companyColor,
              }}
              type="default"
              onClick={onInterestedClick}
              data-testid="not-interested-btn"
            >
              {t('description_page.not_interested_sign_up_section.button')}
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

NotInterestedSignUpSection.propTypes = {
  companyColor: PropTypes.string.isRequired,
  onInterestedClick: PropTypes.func.isRequired,
};

export default NotInterestedSignUpSection;
